import {
  CURRENTUSER,
  USER_REGISTER,
  USER_LOGIN,
  USER_LOGOUT,
} from "../actions";

const initialState = {
  loggedIn: false,
  logInError: false,
  registerError: false,
  id: 0,
  name: null,
  roles: null,
  isAdmin: false,
  registrationSuccess: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CURRENTUSER.SUCCESS:
      const loggedIn = action.response.length === 1,
        roles = loggedIn ? action.response[0].roles : null,
        userIsAdmin =
          roles && (roles.includes("Admin") || roles.includes("admin"));

      return {
        ...state,
        loggedIn,
        logInError: false,
        id: loggedIn ? action.response[0].uid : 0,
        name: loggedIn ? action.response[0].name : null,
        roles: loggedIn ? roles : null,
        isAdmin: userIsAdmin ? true : false,
      };

    case USER_REGISTER.SUCCESS:
      return {
        ...state,
        registrationSuccess: true,
      };

    case USER_REGISTER.FAILURE:
      return {
        ...state,
        registerError: action.error,
      };

    case USER_LOGIN.SUCCESS:
      return {
        ...state,
        loggedIn: true,
        logInError: false,
        id: action.response.current_user.uid,
        name: action.response.current_user.name,
        roles: action.response.current_user.roles,
      };

    case USER_LOGOUT.SUCCESS:
      return {
        ...state,
        loggedIn: false,
        logInError: false,
        id: 0,
        name: null,
        roles: null,
        isAdmin: false,
      };

    case USER_LOGIN.FAILURE:
      return {
        ...state,
        loggedIn: false,
        logInError: action.error,
        id: 0,
        name: null,
        roles: null,
        isAdmin: false,
      };

    default:
      return state;
  }
}
